import { render, staticRenderFns } from "./InputQuestion.vue?vue&type=template&id=49a09850&scoped=true&"
import script from "./InputQuestion.vue?vue&type=script&lang=js&"
export * from "./InputQuestion.vue?vue&type=script&lang=js&"
import style0 from "./InputQuestion.vue?vue&type=style&index=0&id=49a09850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a09850",
  null
  
)

export default component.exports